import { SyntheticEvent } from './SyntheticEvent';
import type * as THREE from 'three';

export class PointerSyntheticEvent extends SyntheticEvent<PointerEvent> {
  private readonly _ray: THREE.Ray;

  private readonly _originViewPortDescriptor: string;

  public constructor(event: PointerEvent, ray: THREE.Ray, originViewPortDescriptor: string) {
    super(event);
    this._ray = ray;
    this._originViewPortDescriptor = originViewPortDescriptor;
  }

  public get ray(): THREE.Ray {
    return this._ray;
  }

  public get originViewPortDescriptor(): string {
    return this._originViewPortDescriptor;
  }
}
